module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-bijvoeglijk-naamwoord.json
// module id = 1299
// module chunks = 198336925090211